import DefaultStyleContainer from "../../../Components/Button/DefaultStyle/DefaultStyleContainer";

const DefaultStyle = () => {
  return <DefaultStyleContainer />;
};

export default DefaultStyle;
